export type FieldValidation = {
	rule: (value: unknown) => boolean | string;
	errorMessage?: string;
};

export interface IPhoneCodeValidationConfig {
	maxLength?: number;
	minLength?: number;
	regexp?: RegExp;
}

export interface IDateISO {
	day: number;
	month: number;
	year: number;
}

export interface IBirthDateEntity {
	value: string;
	label: string;
}

export type TFormatRule = (config: any) => {errorMessage: string; rule: FieldValidation[]};

export enum PageType {
	Editorial = 'Editorial',
	PLP = 'PLP',
	PDP = 'PDP',
	SplashPage = 'SplashPage',
	NOT_FOUND = '404',
	MY_ACCOUNT = 'MyAccount'
}
